import service from '../service.js'

export default {
    getDepartment(){
      return service.get('department')
    },
    addDepartment(div_code, department, abbr, rc_code, status){
        return service.post('department',{
            div_code    : div_code,
            department  : department,
            abbr        : abbr,
            rc_code     : rc_code,
            status      : status
        })
    },
    editDepartment(div_code,dep_code, department, abbr, rc_code, status){
        return service.put('department',{
            div_code    : div_code,
            dep_code    : dep_code,
            department  : department,
            abbr        : abbr,
            rc_code     : rc_code,
            status      : status
        })
    },
}